import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { getTokenDataFromStoredToken } from '../../utils/Auth';
import { tokenDataAtom } from '../../atoms/TokenData';

interface SecureComponentProps {
  children: JSX.Element;
}

const SecureComponent = (props: SecureComponentProps) => {
  const navigate = useNavigate();

  const setTokenData = useSetRecoilState(tokenDataAtom);

  useEffect(() => {
    const tokenData = getTokenDataFromStoredToken();
    if (!tokenData) {
      navigate('/login');
      return;
    }

    setTokenData(tokenData);
  }, []);

  return props.children;
};

export default SecureComponent;
